import React from 'react';
import PropTypes from 'prop-types';

export default function WrongLocationInputMessage(props) {

  return (
    <ul
      className="dc-wrong-location-input-message-list"
      role="listbox"
    >
      <li
        className="dc-wrong-location-input-message-list__item"
        key={0}
      >
        <span className="dc-wrong-location-input-message-list__item__text">
          {props.message}
        </span>
      </li>
    </ul>
  );
}


WrongLocationInputMessage.displayName = 'WrongLocationInputMessage';

WrongLocationInputMessage.propTypes = {
  message: PropTypes.string.isRequired
};
